import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Icon from "../../../../ui/icons/Icon";
import iconsList from "../../../../ui/icons/iconsList";
import ScrollLTR from "../../../../ui/scrollLTR/ScrollLTR";
import useClickOutside from "../../../../../hooks/useClickOutside";
import classes from "./MultiSelect.module.css";

const MultiSelect = ({ filterName, itemField, minWidth, options, defaultsSelected, sortByChar, setFilters, filters }) => {

    const { texts } = useSelector(state => state.translate);
    const [selected, setSelected] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const popupRef = useRef();

    useClickOutside(popupRef, () => {
        setIsOpen(false);
    });

    const toggleSelection = (option) => {
        setSelected(prev =>
            prev.includes(option.value) || prev.some(sel => arraysEqual(sel, option.value)) ? prev.filter(item => item !== option.value) : [...prev, option.value]
        );

        setFilters(prev => {
            const updated = { ...prev };
            updated[itemField] ||= [];
            const filterValues = updated[itemField];
            const includesFilter = filterValues.some(filter => JSON.stringify(filter) === JSON.stringify(option.value));
            !includesFilter ? filterValues.push(option.value) : updated[itemField] = filterValues.filter(filter => JSON.stringify(filter) !== JSON.stringify(option.value));
            if (!updated[itemField].length)
                delete updated[itemField];
            return { ...updated };
        });
    };

    useEffect(() => {
        if (!filters)
            setSelected([]);
        else
            setSelected(filters?.[itemField] || []);
    }, [filters, itemField]);

    const filteredOptions = (options?.filter(option => option?.name?.toLowerCase().includes(searchTerm.toLowerCase())) || []);
    const sortedOptions = sortByChar ? [...filteredOptions].sort((a, b) => a.name.localeCompare(b.name, 'he')) : filteredOptions;

    const arraysEqual = (a, b) => {
        if (!Array.isArray(a) || !Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        const sortedA = [...a].sort();
        const sortedB = [...b].sort();
        return sortedA.every((val, index) => val === sortedB[index]);
    };

    const defaultAppliedRef = useRef(false);

    useEffect(() => {
        if (!defaultAppliedRef.current && (!filters?.[itemField] || filters[itemField].length === 0) && defaultsSelected?.length) {

            defaultsSelected.forEach(group => {
                toggleSelection({
                    name: itemField,
                    value: group
                });
            });
            defaultAppliedRef.current = true;
        }
    }, [defaultsSelected, filters, itemField]);

    return (
        <div className={`${classes.MultiSelect} ${isOpen ? classes.Open : ""}`} ref={popupRef} style={{ minWidth: minWidth }}>
            <div className={classes.SelectBox} onClick={() => setIsOpen(!isOpen)}>
                <p className={classes.Text}>
                    {selected?.length ? `${selected.length} ${texts.itemsSelected}` : texts[filterName]}
                </p>
                <Icon className={classes.Icon} name={iconsList.arrow} size="16px" />
            </div>

            {isOpen && (
                <div className={classes.OptionsList}>
                    <div className={classes.SearchBox}>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder={texts.search || "חפש..."}
                            className={classes.SearchInput}
                        />
                    </div>

                    <ScrollLTR height={"150px"}>
                        {sortedOptions.map((option, index) => (
                            <div key={`${index}+${option.name}`} className={classes.Option}>
                                <div
                                    className={`${classes.Choose} ${selected?.includes(option.value) || selected.some(sel => arraysEqual(sel, option.value)) ? classes.Active : ''}`}
                                    onClick={() => toggleSelection(option)}
                                >
                                    <Icon name="check" size="16px" />
                                </div>
                                <p className={classes.OptionName}>{option.name}</p>
                            </div>
                        ))}
                        {sortedOptions.length === 0 && (
                            <div className={classes.NoResults}>{texts.noResults || "לא נמצאו תוצאות"}</div>
                        )}
                    </ScrollLTR>
                </div>
            )}
        </div>
    );
};
export default MultiSelect